import { Component, Input } from '@angular/core';
import { Labels } from '../app.models';

@Component({
  selector: 'app-service-unavailable',
  templateUrl: './service-unavailable.component.html',
  styleUrls: ['./service-unavailable.component.scss'],
})
export class ServiceUnavailableComponent {
  private _labels: any;
  @Input() public set labels(labels: Labels) {
    this._labels = labels;
  }
  public get labels() {
    return this._labels;
  }

  constructor() {}

  closeWindow() {
    setTimeout(() => {
      window.close();
    }, 400);
  }
}
